var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.name, 'cell']},[_c('span',[_vm._v(_vm._s(_vm.$t('module_creative_product_column_product')))])])}
var staticRenderFns = []

export { render, staticRenderFns }